import classNames from "classnames";
import { Inline } from "PFComponents/containers";
import { TooltipIcon } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import css from "../availability_filter.module.scss";
import { hasReachedLimit } from "../helpers";

type AvailabilityLimitWrapperProps = React.PropsWithChildren<{
  className?: string;
  scope: number;
}>;

export const AvailabilityLimitWrapper = ({ className, scope, children }: AvailabilityLimitWrapperProps) => {
  const { t } = useTranslation("availability");
  const hasReachedScopeLimit = hasReachedLimit(scope);

  return (
    <>
      <div
        className={classNames(className, {
          [css.scopeLimitReached]: hasReachedScopeLimit
        })}
      >
        {children}
      </div>
      {hasReachedScopeLimit && (
        <Inline alignItems="center">
          <Typography withMargin variant="labelRegular" className={css.scopeDisclaimer}>
            {t("disabledByLimit.message")}
          </Typography>
          <TooltipIcon content={t("disabledByLimit.description")} />
        </Inline>
      )}
    </>
  );
};
